// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"b48b20a7","480":"6fd29571"}[chunkId] + ".chunk.css";
};